import PropTypes from 'prop-types';

export const certificatesPropType = PropTypes.shape({
    gold: PropTypes.number,
    silver: PropTypes.number,
    bronze: PropTypes.number,
    goldBars: PropTypes.number,
    total: PropTypes.number
});

export const participationInfoPropType = PropTypes.shape({
    activityPoints: PropTypes.number,
    liveMathsPoints: PropTypes.number,
    skillQuestsPoints: PropTypes.number
});

export const logInInfoPropType = PropTypes.shape({
    signIns: PropTypes.number,
    timeOnline: PropTypes.shape({
        hours: PropTypes.number,
        minutes: PropTypes.number
    })
});

const participationData = PropTypes.shape({
    userProfileId: PropTypes.number,
    certificates: certificatesPropType,
    participationInfo: participationInfoPropType || undefined,
    logInInfo: logInInfoPropType,
    topicParticipations: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            totalFirstAttempt: PropTypes.number,
            totalHighestAttempt: PropTypes.number,
            totalLatestAttempt: PropTypes.number,
            activityParticipations: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number,
                    name: PropTypes.string,
                    firstAttemptResult: PropTypes.number,
                    highestAttemptResult: PropTypes.number,
                    latestAttemptResult: PropTypes.number,
                    firstVsLatest: PropTypes.number,
                    highestVsLatest: PropTypes.number,
                    firstVsHighest: PropTypes.number
                })
            )
        })
    )
});

export default {
    participationData
};



// WEBPACK FOOTER //
// ./containers/participation/student/student-prop-types.js